/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * TeachingTableBase
 * auto generated base class for the model TeachingTableModel.
 */
export const TeachingTableModelBase = ModelBase.named('TeachingTable')
  .props({
    __typename: types.optional(types.literal('TeachingTable'), 'TeachingTable'),
    active: types.union(types.undefined, types.boolean),
    name: types.union(types.undefined, types.string),
    observers: types.union(types.undefined, types.array(types.string)),
    players: types.union(types.undefined, types.array(types.string)),
    price: types.union(types.undefined, types.number),
    stripePriceId: types.union(types.undefined, types.string),
    stripeProductId: types.union(types.undefined, types.string),
    teacherAvatar: types.union(types.undefined, types.null, types.string),
    teacherId: types.union(types.undefined, types.frozen()),
    teacherName: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class TeachingTableModelSelector extends QueryBuilder {
  get active() {
    return this.__attr('active')
  }
  get name() {
    return this.__attr('name')
  }
  get observers() {
    return this.__attr('observers')
  }
  get players() {
    return this.__attr('players')
  }
  get price() {
    return this.__attr('price')
  }
  get stripePriceId() {
    return this.__attr('stripePriceId')
  }
  get stripeProductId() {
    return this.__attr('stripeProductId')
  }
  get teacherAvatar() {
    return this.__attr('teacherAvatar')
  }
  get teacherId() {
    return this.__attr('teacherId')
  }
  get teacherName() {
    return this.__attr('teacherName')
  }
}
export function selectFromTeachingTable() {
  return new TeachingTableModelSelector()
}

export const teachingTableModelPrimitives =
  selectFromTeachingTable().active.name.observers.players.price.stripePriceId.stripeProductId.teacherAvatar.teacherId
    .teacherName
